export default "__VITE_ASSET__517947c0__"